<template>
    <div v-show="!modoEdicao && !modoConferencia">
        <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
        <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


        <div class="form-edit-page row row-space">
            <div class="form-item">
                <template v-if="!globalStore.showSelectEstabelecimento">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
                </template> <template v-else>
                    <EstabelecimentoSelect v-model:idSelecionado="estabelecimentoSelecionado" />
                </template>
            </div>
            
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th class="col-width-char20">Protocolo</th>
                        <th class="col-width-char10">Vistoria</th>
                        <th class="col-width-char10">Prazo</th>
                        <th class="col-width-char10">N/C</th>
                        <th>Inspetor</th>
                        <th class="col-width-char30">Situação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(pla08, index) in lsDados" :key="pla08.id" @click="onClickItem(pla08)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td class="col-width-char20">{{ pla08.xsequencia }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(pla08.dtvistoria) }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(pla08.dtprazo) }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatInteger(pla08.qtd_nc) }}</td>
                        <td>{{ pla08.nmvistoriador }}</td>
                        <td class="col-width-char30">{{ pla08.xstatus }}</td>
                    </tr>
                </tbody>
            </table>
        </div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <template v-if="modoConferencia">
        <Pla08EditConferirPage :idEdicao="idEdicao" @close="modoConferencia = false" @salvo="lerDados" />
    </template>


    <template v-if="modoEdicao">
        <Pla08EditPage :idEdicao="idEdicao" @close="modoEdicao = false" @salvo="lerDados" />
    </template>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport.js';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import Pla08EditConferirPage from '../formularios/Pla08EditConferirPage.vue';
import Pla08EditPage from '../formularios/Pla08EditPage.vue';

const emit = defineEmits(['close']);
const estabelecimentoSelecionado = ref(null);
const idEdicao = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoConferencia = ref(false);
const modoEdicao = ref(false);
const msgAlerta = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idestabelecimento: (globalStore.showSelectEstabelecimento) ? estabelecimentoSelecionado.value : globalStore.idestabelecimento};
        const req = await Api.genericPost('/lspla/pla08_pendentes', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

async function onClickItem(obj){
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        // VERIFICA NECESSIDADE DE GERAR RAC E ATUALIZAR O CÓDIGO PLA08
        console.log(obj);
        if (!obj.idpla08){
            console.log(' >>> NULO');

            const rAdd = await Api.genericPost('/pla/exec_requisicao', {
                id: obj.idpla06,
                idestabelecimento: globalStore.idestabelecimento,
                nmrequisicao: 'pl08_abertura',
                idusuario: globalStore.idusuario,
                idlogin: globalStore.idlogin});
            if (rAdd.bolok==1){
                console.log('OK');
                obj.idpla08 = rAdd.id;
            }else{throw new Error(rAdd.erro)}
        }

        if (obj.idpla08){
            idEdicao.value = obj.idpla08;
            modoConferencia.value = (obj.status === 2 || obj.status === 3);
            modoEdicao.value = !modoConferencia.value;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>